import { render, staticRenderFns } from "./LandingUpgradePlan.vue?vue&type=template&id=f27cbcd2&"
import script from "./LandingUpgradePlan.vue?vue&type=script&lang=js&"
export * from "./LandingUpgradePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports